// IE 2026 10 30 / ODOO-5800 (p099: pm_history record slim)
// «Історія змін» (pm_history): запрос вёз ВСЮ запись виджета (D&S Balance: doc ~705 КБ — params 573 КБ, viewList 167 КБ, viewParams 19 КБ). Бэк pm_history*
// читает из записи только: id, doc.params.{WHERE, fieldSelectors, fieldsMapping, history, data_scheme, date_fact_stock, fact_stock_day, compare_*, prev_process_model,
// pm_history_tab} и из data_layout2 — только use / attr_type / template / attrs узлов и binding / use / attr_type / title(_uk/_ru) полей (dl_levels, dl_bindings,
// report_has_dates). Поэтому в запрос идёт урезанная КОПИЯ: viewList / viewParams / tooltip* / llm_instruction и тяжёлые ключи params выброшены, data_layout2 — скелет.
// Живая запись не меняется (копия doc и doc.params). Урезаем ТОЛЬКО когда view в запросе исключён (fe.data.pmHistorySlim): с view бэк кладёт виджет в кэш
// (widget_cache_key) вместе с записью «как прислана» — следующий select отчёта работал бы на скелете DL.
// Выключатель fe.data.pmHistoryRecordSlim (дефолт ВКЛ; false — запись целиком). Чистые функции без DOM — tests/unit/pmHistoryRecordSlim.test.mjs
export const PM_HISTORY_RECORD_SLIM_FLAG = 'fe.data.pmHistoryRecordSlim'

const DOC_DROP = ['viewList', 'viewParams', 'tooltip', 'tooltip_uk', 'tooltip_ru', 'llm_instruction']
const PARAMS_DROP = ['conditional_format', 'source_segments', 'option_groups', 'data_layout2_fields']
const NODE_KEEP = ['use', 'attr_type', 'template']
const FIELD_KEEP = ['binding', 'use', 'attr_type', 'title', 'title_uk', 'title_ru']

const isObj = (v) => v != null && typeof v === 'object' && !Array.isArray(v)
const has = (o, k) => Object.prototype.hasOwnProperty.call(o, k)

export function pmHistory_recordSlimOn(setting) {   // чтение флага (нет читателя / ошибка — ВКЛ)
    try { return typeof setting !== 'function' || setting(PM_HISTORY_RECORD_SLIM_FLAG, true) !== false } catch (e) { return true }
}

function pick(src, keys) {
    const out = {}
    for (const k of keys) if (has(src, k)) out[k] = src[k]
    return out
}

// скелет узла DL: use / attr_type / template, fields (binding / use / attr_type / title*), attrs — рекурсивно (глубина сохраняется)
export function pmHistory_dlSkeleton(nodes) {
    if (!Array.isArray(nodes)) return nodes
    return nodes.map((n) => {
        if (!isObj(n)) return n
        const out = pick(n, NODE_KEEP)
        if (has(n, 'fields')) out.fields = Array.isArray(n.fields) ? n.fields.map((f) => (isObj(f) ? pick(f, FIELD_KEEP) : f)) : n.fields
        if (has(n, 'attrs')) out.attrs = pmHistory_dlSkeleton(n.attrs)
        return out
    })
}

// урезанная копия записи для запроса pm_history; не-объект / запись без doc — как есть. Вход не мутируется.
export function pmHistory_slimRecord(record) {
    if (!isObj(record) || !isObj(record.doc)) return record
    const doc = {}
    for (const k of Object.keys(record.doc)) if (!DOC_DROP.includes(k)) doc[k] = record.doc[k]
    if (isObj(record.doc.params)) {
        const params = {}
        for (const k of Object.keys(record.doc.params)) if (!PARAMS_DROP.includes(k)) params[k] = record.doc.params[k]
        if (has(params, 'data_layout2')) params.data_layout2 = pmHistory_dlSkeleton(params.data_layout2)
        doc.params = params
    }
    return { ...record, doc }
}

// запись для запроса: method pm_history + view исключён из запроса (в wt нет ключа view) + флаг включён → урезанная копия; иначе та же запись
export function pmHistory_recordForRequest(method, widgetToTransfer, setting) {
    const wt = isObj(widgetToTransfer) ? widgetToTransfer : {}
    if (method !== 'pm_history' || has(wt, 'view') || !pmHistory_recordSlimOn(setting)) return wt.record
    return pmHistory_slimRecord(wt.record)
}
